module.exports = __webpack_public_path__ + "static/media/close.b00551ea.svg";